import { render } from "./DocumentsPanel.vue?vue&type=template&id=a0edfff4&scoped=true&ts=true"
import script from "./DocumentsPanel.vue?vue&type=script&lang=ts"
export * from "./DocumentsPanel.vue?vue&type=script&lang=ts"

import "./DocumentsPanel.vue?vue&type=style&index=0&id=a0edfff4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0edfff4"]])

export default __exports__